<template>
  <UiOnClickOutside :do="closeCountrySelectModel">
    <div>
      <!-- TITLE -->
      <label
        v-if="title"
        for="title"
        class="text-text-color text-xs title-margin font-poppins flex"
      >
        {{ title }}
        <span v-if="rules.includes('required')" class="text-text-color-danger pl-1">*</span>
      </label>
      <!-- CONTAINER STARTED -->
      <div
        :style="fixDesign ? 'padding-top:5px !important;padding-bottom:5px !important' : ''"
        :class="[customBg ? customBg : 'input-bg initial-border', customClasses]"
        class="flex phone-number-input-container relative flex-row h-14 md:h-16"
      >
        <!-- COUNTRY SELECT -->

        <div
          class="flag-continer flex flex-row my-auto ml-2 mr-6"
          @click="toogleCountrySelectModel"
        >
          <div class="shadow-sm country-flag flex flex-row items-center pl-2">
            <div class="selected-country-flag">
              <CountryFlag :country="selectedCountryFlag" class="" size="normal" />
            </div>
            <div class="dorpdown-icon mx-auto">
              <Icon
                class="icon"
                icon="chevron-bottom"
                color="primary-grey-light"
                height="8.25"
                width="14.50"
              />
            </div>
          </div>
        </div>
        <!-- COUNTRY DROPDOWN -->
        <div v-show="countrySelectModel" class="absolute shadow-xl px-2 country-select-dropdown">
          <!-- SEARCH -->
          <div class="flex flex-row search-icon-container py-3 px-2 gap-2">
            <div class="search-icon my-auto pr-4">
              <Icon class="icon" icon="search" color="primary-grey-light" height="15" width="15" />
            </div>
            <div class="search-input">
              <input
                v-model="searchedValue"
                :disabled="disabled"
                class="focus:outline-none phone-number-input bg-bg-light w-full"
                placeholder="Search"
              />
            </div>
          </div>
          <!-- HR-LINE -->
          <div class="custom-hr my-2 mx-1" />
          <!-- COUNTRY LIST -->
          <div class="country-list-container">
            <div
              v-for="(country, index) in filteredCountries"
              :key="index"
              class="flex flex-row w-100 country-list"
              @click="
                updateSelectedValue({
                  name: country[0],
                  alpha2Code: country[1],
                  countryCode: '+' + country[2],
                  placeholder: country[3],
                })
              "
            >
              <span>
                <CountryFlag :country="country[1].toLowerCase()" size="normal" />
              </span>
              <span class="px-2 pt-2 country-name">
                {{ country[0] }} &nbsp;&nbsp; + {{ country[2] }}
              </span>
            </div>
            <div v-if="filteredCountries.length === 0" class="ml-2 pt-3 text-gray-600">
              No Record Found
            </div>
          </div>
        </div>
        <!-- NUMBER INPUT -->
        <div class="number-container flex items-center" :style="fixDesign ? 'padding-top:0px' : ''">
          <span class="number-format">{{ selectedCountryCode }}</span>
          <input
            :class="[customBg ? customBg : 'input-bg']"
            class="focus:outline-none phone-number-input mr-2 w-full"
            :placeholder="placeHolder"
            name="Phone Number"
            type="text"
            :disabled="disabled"
            @input="emitValue($event)"
          />
          <!-- phone number verification check here -->
          <small
            v-if="phoneErrorMessage"
            :style="errorMsgStyle"
            class="error-msg rtl:mt-1 ltr:-mt-0 mr-1"
          >
            {{ phoneErrorMessage }}
          </small>
        </div>
      </div>
    </div>
  </UiOnClickOutside>
</template>

<script>
import Icon from '@src/components/icons/icon.vue'
import countries from '@src/constants/countriesArray'
import CountryFlag from 'vue-country-flag-next'
import parsePhoneNumber from 'libphonenumber-js'
import phoneContants from '@src/constants/phonenumber-constants'
import { mapState } from 'vuex'
import UiOnClickOutside from '@/src/components/misc/UiOnClickOutside.vue'

export default {
  name: 'App',
  components: {
    Icon,
    CountryFlag,
    UiOnClickOutside,
  },
  props: {
    rules: { type: String, default: '' },
    title: { type: String, default: '' },
    customBg: { type: String, default: '' },
    customPadding: { type: String, default: '' },
    customClasses: { type: String, default: '' },
    errorMsgStyle: { type: Object, default: () => ({}) },
    isVerified: {
      type: Boolean,
      default: false,
    },
    fixDesign: {
      type: Boolean,
      default: false,
    } /* used rarely when design fluctuate at some point */,
    smallHeight: {
      type: Boolean,
      default: false,
    } /* used rarely when design fluctuate at some point */,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phoneErrorMessage: '',
      phoneNumberVerified: false,
      searchedValue: '',
      filteredCountries: [],
      selectedCountryFlag: '',
      selectedCountryCode: '',
      placeHolder: '(101)',
      countrySelectModel: false,
      allCountries: countries,
      dark: false,
      hasLoaderActive: false,
      hasErrorActive: false,
      phoneNumber: '',
    }
  },
  computed: {
    ...mapState(['currentSelectedLanguage']),
  },

  watch: {
    /**
     * @description SEARCH IS IPLEMENTED HERE
     */
    searchedValue: {
      handler: function (searchString) {
        var filteredCountries = []
        searchString = searchString.toLowerCase()
        var withoutPlusSign = searchString.replace('+', '')
        this.allCountries.forEach((val, ind) => {
          if (
            val[0].toLowerCase().includes(searchString) ||
            val[1].toLowerCase().includes(searchString) ||
            val[2].toLowerCase().includes(withoutPlusSign)
          ) {
            filteredCountries.push(val)
          }
        })
        this.filteredCountries = filteredCountries
        if (searchString === '' || searchString === ' ') this.filteredCountries = this.allCountries
      },
      immediate: true,
    },
    phoneNumber: {
      immediate: true,
      handler(value) {
        if (this.rules.includes('required') && value === '')
          this.phoneErrorMessage = 'Phone Required'
      },
    },
  },
  created() {
    this.selectedCountryFlag = phoneContants.DEFAULT_COUNTRY_FLAG
    this.selectedCountryCode = phoneContants.DEFAULT_COUNTRY_CODE
    this.placeHolder = phoneContants.DEFAULT_COUNTRY_PLACEHOLDER
  },
  methods: {
    /**
     * @description For toggling country list model
     */
    toogleCountrySelectModel() {
      if (!this.disabled) this.countrySelectModel = !this.countrySelectModel
    },
    /**
     * @description For toggling country list model
     */
    closeCountrySelectModel() {
      this.countrySelectModel = false
    },
    /**
     * @description used to select new country.
     */
    updateSelectedValue(selectedCountryObject) {
      this.selectedCountryFlag = selectedCountryObject.alpha2Code
      this.selectedCountryCode = selectedCountryObject.countryCode
      this.placeHolder = selectedCountryObject.placeholder
      this.toogleCountrySelectModel()
    },
    emitValue(e, a) {
      if (this.currentSelectedLanguage.short === 'ar') {
        this.phoneNumber = e.target.value.toArabicDigits()
      } else {this.phoneNumber = e.target.value}

      let customerPhoneNumber = parsePhoneNumber(`${this.selectedCountryCode}${e.target.value}`)
      if (customerPhoneNumber) return this.$emit('update:modelValue', customerPhoneNumber)
      if (customerPhoneNumber && customerPhoneNumber.isValid()) {
        this.phoneNumberVerified = true
        this.phoneErrorMessage = ''
        this.$emit('isPhoneValid', true)

        return
      }

      this.phoneNumberVerified = false
      if (this.rules.includes('required')) {
        this.$emit('isPhoneValid', false)
        this.phoneErrorMessage = 'not valid number'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* SCSS MIXINS HERE ALWAYS DEFINE THEM ON TOP */
@mixin border {
  border: 1px solid var(--bg-primary);
}
@mixin p-t-b-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* STATIC SCSS */

/* LTR RTL */
.phone-number-input-container {
  direction: ltr !important;
  border-radius: 11px;
  border: 1px solid #70707052;
  span {
    direction: ltr !important;
  }
  div {
    direction: ltr !important;
  }
  input {
    direction: ltr !important;
  }
}
.input-bg {
  border: none;
}
.absolute-text {
  top: 13px;
  right: 11px;
}
.error-border {
  background-color: var(--bg-error) !important;
}
.error-bg {
  background-color: var(--bg-error) !important;
}
.error-msg {
  position: absolute;
  right: -1px;
  bottom: -20px;
  width: fit-content;
  font-size: 12px;
  font-style: italic;
  color: var(--text-color-danger);
}
body[dir='rtl'] {
  .error-msg {
    right: inherit;
    left: 0;
  }
}
.error-pos-fix {
  right: -28px;
  bottom: -20px;
}
.title-margin {
  margin-bottom: 5px;
}
.country-flag {
  @include border;

  width: 100%;
  max-width: 80px;
  border-radius: 11px;
}
.initial-border {
  border: 1px solid #70707052;
}
.country-select-dropdown {
  top: 50px;
  z-index: 11;
  width: 100%;
  min-width: 257px;
  max-width: 600px;
  @include p-t-b-10;

  background-color: white;
  border-radius: 6px;
  box-shadow: 12px 0 15px -10px #0003, -16px 0 6px -12px #0003, 0 9px 6px -2px #0003;
}
.flag-continer {
  width: 80px;
  height: 46px;
}
.normal-flag {
  border-radius: 4px;
}
.number-container {
  width: 70%;
}
.number-format {
  font-size: 16px;
  color: #777d8b;
  letter-spacing: 0;
}
.phone-number-input {
  padding-top: 0;
  padding-left: 5px;
  font-size: 16px;
}
.search-icon-container {
  background: #f4f5fa 0% 0% no-repeat padding-box;
  border-radius: 11px;
  border: 1px solid #70707052;
}
.country-list-container {
  min-height: 50px;
  max-height: 250px;
  overflow: auto;
}
.country-list {
  color: #777d8b;
  &:hover {
    @include border;

    padding-right: 10px;
    padding-left: 10px;
    color: #1d273e;
    border-radius: 4px;
  }
}
.selected-country-flag {
  margin-top: -4px;
}
.custom-hr {
  @include border;
}
.small-height {
  .phone-number-input-container {
    min-height: 43px;
    max-height: 42px;
  }
  .flag-continer {
    max-width: 67px;
    max-height: 33px;
  }
  .number-container {
    max-height: 42px;
  }
  .country-select-dropdown {
    top: 37px;
  }
}

/* MEDIA QUERIES START FROM HERE */
@media only screen and (max-width: 1200px) and (min-width: 1000px) {
  .flag-continer {
    width: 25% !important;
  }
  .number-container {
    width: 75% !important;
    padding: 0;
  }
}
@media only screen and (max-width: 500px) and (min-width: 400px) {
  .flag-continer {
    width: 25% !important;
  }
  .number-container {
    width: 75% !important;
  }
}
@media only screen and (max-width: 375px) and (min-width: 300px) {
  .flag-continer {
    width: 28% !important;
  }
  .number-container {
    width: 72% !important;
  }
}

/* THEME */
[theme-is='dark'] {
  input {
    background-color: var(--primary-white);
  }
  .country-select-dropdown {
    background-color: var(--primary-white);
  }
  .search-icon-container {
    background-color: var(--primary-white);
  }
  .error-border {
    background-color: var(--primary-white);
  }
}
</style>
